module.exports = __webpack_public_path__ + "static/team-10-145b16c6223ba21be1fe7b780ae02496.jpg";